export class Order {
  public page: number;
  public pageDefault: number;
  public limit: number;
  public search: string;
  public orderBy: string;
  public isAsc: boolean;
  public firstDate: string;
  public lastDate: string;
  public filterType: number;
  public type: number;
  public typeCode: number;
  public status: number;

  constructor(
    page = 1,
    pageDefault = 1,
    limit = 1,
    search = "",
    orderBy = "",
    isAsc = false,
    firstDate = "",
    lastDate = "",
    filterType = 0,
    type = 0,
    typeCode = 0,
    status = 0
  ) {
    this.page = page;
    this.pageDefault = pageDefault;
    this.limit = limit;
    this.search = search;
    this.orderBy = orderBy;
    this.isAsc = isAsc;
    this.firstDate = firstDate;
    this.lastDate = lastDate;
    this.filterType = filterType;
    this.type = type;
    this.typeCode = typeCode;
    this.status = status;
  }
}
